import { ref } from 'vue';

// Estado global del menú móvil
const showMobileMenu = ref(false);
const mountMobileMenu = ref(true);

export function useMobileMenu() {
  const toggleMobileMenu = () => {
    showMobileMenu.value = !showMobileMenu.value;
  };

  const closeMobileMenu = () => {
    showMobileMenu.value = false;
  };

  const openMobileMenu = () => {
    showMobileMenu.value = true;
  };

  const setMountMobileMenu = (value) => {
    mountMobileMenu.value = value;
  };

  return {
    showMobileMenu,
    mountMobileMenu,
    toggleMobileMenu,
    closeMobileMenu,
    openMobileMenu,
    setMountMobileMenu,
  };
}
